import { Layout, theme, Typography } from "antd";
import { useLocation } from "react-router-dom";

import EditPosition from "../components/positions/EditPosition";

const { Content } = Layout;

const PositionEdit = () => {
  const location = useLocation();
  const id = location.state.id;

  const {
    token: { colorBgContainer },
  } = theme.useToken();
  return (
    <Layout
      style={{
        marginLeft: 200,
      }}
    >
      <Content
        style={{
          margin: "24px 16px 0",
          overflow: "initial",
        }}
      >
        <div
          className="page-container"
          style={{
            background: colorBgContainer,
          }}
        >
          <Typography.Title level={5} className="titles-start">
            DÜZƏLİŞ ET
          </Typography.Title>
          <EditPosition id={id} />
        </div>
      </Content>
    </Layout>
  );
};

export default PositionEdit;
